// AUTO-GENERATED by scripts/gen-keyword-tops.mjs — do not edit by hand.
export const NAATI_KEYWORDS_TH_TOTAL = 399;
export const NAATI_KEYWORDS_EN_TOTAL = 224;
export const NAATI_KEYWORDS_TOTAL = 623;
export const NAATI_FAQ_TH_TOTAL = 143;
export const NAATI_FAQ_EN_TOTAL = 250;
